<label i18n="@@FILE_CACHE_DESCRIPTION">
  3D models you open are kept on this device so they load faster next time.
  Files not used for 3 months are removed automatically.
</label>
<div class="simlab-file-cache__usage">
  <span i18n="@@FILE_CACHE_USAGE">Space used:</span>
  <span class="simlab-file-cache__usage-value">{{ usage() }}</span>
</div>
<button
  class="simlab-file-cache__clear"
  type="button"
  data-cy="personal-settings-clear-cache"
  design-flat-button
  designButtonColor="primary"
  [disabled]="!available || clearing()"
  (click)="clear()"
>
  <div i18n="@@FILE_CACHE_CLEAR">Clear cache</div>
</button>
